export const PUBLIC_FILTER_KEYS = [
	"project",
	"sprint",
	"status",
	"priority",
	"assignee",
	"q",
] as const;
export type PublicFilterKey = (typeof PUBLIC_FILTER_KEYS)[number];
export type PublicFilterValues = Record<PublicFilterKey, string>;

export type PublicView = "roadmap" | "board" | "list";

// The sprint filter defaults to the active sprint, so "All Sprints" needs its
// own URL value to stay distinct from "not chosen yet".
export const ALL_SPRINTS = "all";
